import Vue from "vue";
import OptionRow from "./../components/OptionRow";
import FiasInfo from "./../components/FiasInfo";

Vue.component("OptionRow", OptionRow);
Vue.component("FiasInfo", FiasInfo);
